/**
 * Wizard inventory search + Google maps/geocode (from location.attach).
 * Called after fetchEventsByLatLng exists so Continue/search keep the same bindings.
 */
(function (global) {
  if (global.WorkshopBookingLocationSearch) return;
  global.WorkshopBookingLocationSearch = {
    attach: function (S) {
      if (!S) return;
      var booking = S.booking;
      var eventsRoot = S.eventsRoot;
      var googleKey = S.googleKey;
      var locInput = S.locInput;
      var ensureGooglePlacesLoaded = S.ensureGooglePlacesLoaded;
      var fetchEventsByLatLng = S.fetchEventsByLatLng;
      var wbSetLocationUi = S.wbSetLocationUi;
      var wbWizardApplyInventoryFilter = S.wbWizardApplyInventoryFilter;
      var wbWizardFormatVenueSearchLabel = S.wbWizardFormatVenueSearchLabel;
      var wbWizardHasRenderableVenueList = S.wbWizardHasRenderableVenueList;
      var wbWizardInventorySearchActive = S.wbWizardInventorySearchActive;
      var wbWizardInventorySearchSubmit = S.wbWizardInventorySearchSubmit;
      var wbWizardLiveFilterFromInput = S.wbWizardLiveFilterFromInput;
      var wbWizardMatchScore = S.wbWizardMatchScore;
      var wbWizardStoreInitialVenueList = S.wbWizardStoreInitialVenueList;
      var wbWizardVenueCoords = S.wbWizardVenueCoords;
      var wbWizardVenueEventMeta = S.wbWizardVenueEventMeta;
      var wbWizardVenueIsWaitlist = S.wbWizardVenueIsWaitlist;
      var wbWizardVenueSearchCityLabel = S.wbWizardVenueSearchCityLabel;
      var wbResolveVenueCardImage = S.wbResolveVenueCardImage;

    var wbGeocodeCache = Object.create(null);
    var googleMapsCoreLoadPromise = null;
    var WEST_BIAS = { lat: 37.2, lng: -119.5, radius: 900000 };

    function hubApi() {
      return global.WorkshopBookingWizardHub || null;
    }

    function hubCityPickerVisible() {
      var Hub = hubApi();
      return !!(Hub && typeof Hub.cityPickerVisible === 'function' && Hub.cityPickerVisible(booking));
    }

    function hubApplyOrigin(lat, lng, label, source) {
      var Hub = hubApi();
      if (!Hub || typeof Hub.applySearchOrigin !== 'function' || !hubCityPickerVisible()) return false;
      Hub.applySearchOrigin(booking, {
        lat: Number(lat),
        lng: Number(lng),
        label: label || '',
        source: source || 'place'
      });
      if (typeof window !== 'undefined') {
        window.__WB_USER_CHOSEN_LOCATION__ = true;
        window.__WORKSHOP_LOCATION__ = {
          lat: Number(lat),
          lng: Number(lng),
          label: label || '',
          source: source || 'place',
          country: 'US'
        };
      }
      if (typeof wbSetLocationUi === 'function') wbSetLocationUi({ label: label || '' });
      return true;
    }

    function ensureGoogleMapsCoreLoaded(key) {
      if (window.google && window.google.maps && window.google.maps.Geocoder) {
        return Promise.resolve();
      }
      if (!key || !String(key).trim()) {
        return Promise.reject(new Error('[WB] No Google key'));
      }
      if (googleMapsCoreLoadPromise) return googleMapsCoreLoadPromise;
      var existing = document.querySelector('script[src*="maps.googleapis.com/maps/api/js"]');
      if (existing) {
        googleMapsCoreLoadPromise = new Promise(function (resolve, reject) {
          var start = Date.now();
          var check = function () {
            if (window.google && window.google.maps && window.google.maps.Geocoder) {
              googleMapsCoreLoadPromise = null;
              resolve();
              return;
            }
            if (Date.now() - start > 8000) {
              googleMapsCoreLoadPromise = null;
              reject(new Error('[WB] Google Maps core load timeout'));
              return;
            }
            setTimeout(check, 100);
          };
          check();
        });
        return googleMapsCoreLoadPromise;
      }
      googleMapsCoreLoadPromise = new Promise(function (resolve, reject) {
        var cbName = '__WB_GMAPS_CORE_' + Date.now();
        var timeout = setTimeout(function () {
          delete window[cbName];
          googleMapsCoreLoadPromise = null;
          reject(new Error('[WB] Google Maps core load timeout'));
        }, 8000);
        window[cbName] = function () {
          clearTimeout(timeout);
          delete window[cbName];
          googleMapsCoreLoadPromise = null;
          if (window.google && window.google.maps && window.google.maps.Geocoder) resolve();
          else reject(new Error('[WB] Geocoder unavailable'));
        };
        var s = document.createElement('script');
        s.async = true;
        s.src =
          'https://maps.googleapis.com/maps/api/js?key=' +
          encodeURIComponent(key) +
          '&v=weekly&callback=' +
          cbName;
        s.onerror = function () {
          clearTimeout(timeout);
          delete window[cbName];
          googleMapsCoreLoadPromise = null;
          reject(new Error('[WB] Google Maps script failed'));
        };
        document.head.appendChild(s);
      });
      return googleMapsCoreLoadPromise;
    }

    function wbWizardReadGeocodeCache(query) {
      var cacheKey = String(query || '').trim().toLowerCase();
      if (!cacheKey) return null;
      if (wbGeocodeCache[cacheKey]) return wbGeocodeCache[cacheKey];
      try {
        var raw = sessionStorage.getItem('wb_geo:' + cacheKey);
        if (!raw) return null;
        var parsed = JSON.parse(raw);
        if (parsed && Number.isFinite(parsed.lat) && Number.isFinite(parsed.lng)) {
          wbGeocodeCache[cacheKey] = parsed;
          return parsed;
        }
      } catch (_) {}
      return null;
    }

    function wbWizardWriteGeocodeCache(query, resolved) {
      var cacheKey = String(query || '').trim().toLowerCase();
      if (!cacheKey || !resolved) return;
      wbGeocodeCache[cacheKey] = resolved;
      try {
        sessionStorage.setItem('wb_geo:' + cacheKey, JSON.stringify(resolved));
      } catch (_) {}
    }

    function wbWizardGeocodeAndRecenter(query) {
      if (!wbWizardInventorySearchActive()) return;
      var q = String(query || '').trim();
      if (q.length < 3 || !googleKey) return;
      if (booking.__wbWizardLastGeocodeQ === q) return;
      function applyResolved(resolved) {
        if (!resolved) return;
        if (locInput && String(locInput.value || '').trim() !== q) return;
        booking.__wbWizardLastGeocodeQ = q;
        if (typeof window !== 'undefined') window.__WB_USER_CHOSEN_LOCATION__ = true;
        if (hubApplyOrigin(resolved.lat, resolved.lng, q, 'geocode_search')) return;
        fetchEventsByLatLng(booking, resolved.lat, resolved.lng, 250, {
          source: 'geocode_search',
          label: q
        });
      }
      var cached = wbWizardReadGeocodeCache(q);
      if (cached) {
        applyResolved(cached);
        return;
      }
      ensureGoogleMapsCoreLoaded(googleKey)
        .then(function () {
          var geocoder = new google.maps.Geocoder();
          geocoder.geocode(
            { address: q, componentRestrictions: { country: 'US' } },
            function (results, status) {
              if (status !== 'OK' || !results || !results[0] || !results[0].geometry) return;
              var loc = results[0].geometry.location;
              var resolved = {
                lat: typeof loc.lat === 'function' ? loc.lat() : loc.lat,
                lng: typeof loc.lng === 'function' ? loc.lng() : loc.lng
              };
              if (!Number.isFinite(resolved.lat) || !Number.isFinite(resolved.lng)) return;
              wbWizardWriteGeocodeCache(q, resolved);
              applyResolved(resolved);
            }
          );
        })
        .catch(function (err) {
          if (window.__WB_DIAG__) console.warn('[WB] geocode search skipped', err);
        });
    }

    function wbWizardEnsureSuggestionList() {
      var wrap = locInput && locInput.closest('.wb-search-input-wrap');
      if (!wrap) return null;
      var list = wrap.querySelector('#wbw-search-suggestions');
      if (!list) {
        list = document.createElement('ul');
        list.id = 'wbw-search-suggestions';
        list.className = 'wbw-search-suggestions';
        list.setAttribute('role', 'listbox');
        list.hidden = true;
        wrap.appendChild(list);
      }
      return list;
    }

    function wbWizardHideGoogleSuggestions() {
      booking.__wbWizardPredictions = [];
      booking.__wbWizardVenueSuggestions = [];
      booking.__wbWizardCitySuggestions = [];
      booking.__wbWizardPredictFor = '';
      var list = locInput && locInput.closest('.wb-search-input-wrap')
        ? locInput.closest('.wb-search-input-wrap').querySelector('#wbw-search-suggestions')
        : null;
      if (list) {
        list.innerHTML = '';
        list.hidden = true;
      }
      if (locInput) locInput.setAttribute('aria-expanded', 'false');
    }

    function wbWizardBuildPlaceSuggestion(pred, index) {
      var li = document.createElement('li');
      li.className = 'wbw-search-suggestion wbw-search-suggestion--place';
      li.setAttribute('role', 'option');
      li.setAttribute('data-place-id', pred.place_id || '');
      li.setAttribute('data-index', String(index));
      var thumb = document.createElement('span');
      thumb.className = 'wbw-search-suggestion__thumb wbw-search-suggestion__thumb--pin';
      thumb.setAttribute('aria-hidden', 'true');
      var body = document.createElement('span');
      body.className = 'wbw-search-suggestion__body';
      var main = document.createElement('span');
      main.className = 'wbw-search-suggestion__label';
      main.textContent =
        (pred.structured_formatting && pred.structured_formatting.main_text) || pred.description || '';
      var meta = document.createElement('span');
      meta.className = 'wbw-search-suggestion__meta';
      meta.textContent =
        (pred.structured_formatting && pred.structured_formatting.secondary_text) || '';
      body.appendChild(main);
      if (meta.textContent) body.appendChild(meta);
      li.appendChild(thumb);
      li.appendChild(body);
      li.addEventListener('mousedown', function (e) {
        e.preventDefault();
        wbWizardSelectGooglePrediction(pred);
      });
      return li;
    }

    function wbWizardSelectHubCity(row) {
      if (!row || !row.btn) return;
      var label = row.label || '';
      if (locInput) locInput.value = label;
      if (typeof booking.__wbWizardSyncSearchClearBtn === 'function') booking.__wbWizardSyncSearchClearBtn();
      if (typeof booking.__wbWizardSyncSearchReel === 'function') booking.__wbWizardSyncSearchReel();
      wbWizardHideGoogleSuggestions();
      row.btn.hidden = false;
      try {
        row.btn.click();
      } catch (_) {}
    }

    function wbWizardBuildCitySuggestion(row, index) {
      if (!row) return null;
      var li = document.createElement('li');
      li.className = 'wbw-search-suggestion wbw-search-suggestion--venue wbw-search-suggestion--city';
      li.setAttribute('role', 'option');
      li.setAttribute('data-hub-city', row.city || '');
      li.setAttribute('data-index', String(index));
      var thumb = document.createElement('span');
      thumb.className = 'wbw-search-suggestion__thumb';
      thumb.setAttribute('aria-hidden', 'true');
      if (row.image) {
        var img = document.createElement('img');
        img.src = row.image;
        img.alt = '';
        img.loading = 'lazy';
        thumb.appendChild(img);
      } else {
        thumb.classList.add('wbw-search-suggestion__thumb--empty');
      }
      var body = document.createElement('span');
      body.className = 'wbw-search-suggestion__body';
      var top = document.createElement('span');
      top.className = 'wbw-search-suggestion__top';
      var main = document.createElement('span');
      main.className = 'wbw-search-suggestion__label';
      main.textContent = row.label || row.city || '';
      var badge = document.createElement('span');
      badge.className = 'wbw-search-suggestion__badge';
      badge.textContent = 'City';
      top.appendChild(main);
      top.appendChild(badge);
      body.appendChild(top);
      if (row.state) {
        var sub = document.createElement('span');
        sub.className = 'wbw-search-suggestion__sub';
        var meta = document.createElement('span');
        meta.className = 'wbw-search-suggestion__meta';
        meta.textContent = row.state;
        sub.appendChild(meta);
        body.appendChild(sub);
      }
      li.appendChild(thumb);
      li.appendChild(body);
      li.addEventListener('mousedown', function (e) {
        e.preventDefault();
        wbWizardSelectHubCity(row);
      });
      return li;
    }

    function wbWizardBuildVenueSuggestion(row, index) {
      var venue = row && row.venue;
      if (!venue) return null;
      var isWaitlist = wbWizardVenueIsWaitlist(venue);
      var li = document.createElement('li');
      li.className =
        'wbw-search-suggestion wbw-search-suggestion--venue' +
        (isWaitlist ? ' wbw-search-suggestion--waitlist' : ' wbw-search-suggestion--event');
      li.setAttribute('role', 'option');
      li.setAttribute('data-venue-ref-id', row.refId || '');
      li.setAttribute('data-index', String(index));
      var labelText = row.label || wbWizardFormatVenueSearchLabel(venue, row.group) || '';
      var thumb = document.createElement('span');
      thumb.className = 'wbw-search-suggestion__thumb';
      thumb.setAttribute('aria-hidden', 'true');
      var imgUrl =
        typeof wbResolveVenueCardImage === 'function'
          ? wbResolveVenueCardImage(venue, labelText, booking)
          : '';
      if (imgUrl) {
        var img = document.createElement('img');
        img.src = imgUrl;
        img.alt = '';
        img.loading = 'lazy';
        thumb.appendChild(img);
      } else {
        thumb.classList.add('wbw-search-suggestion__thumb--empty');
      }
      var body = document.createElement('span');
      body.className = 'wbw-search-suggestion__body';
      var top = document.createElement('span');
      top.className = 'wbw-search-suggestion__top';
      var main = document.createElement('span');
      main.className = 'wbw-search-suggestion__label';
      main.textContent = labelText;
      var badge = document.createElement('span');
      badge.className = 'wbw-search-suggestion__badge';
      badge.textContent = isWaitlist ? 'Waitlist' : 'Event';
      top.appendChild(main);
      top.appendChild(badge);
      body.appendChild(top);
      var sub = document.createElement('span');
      sub.className = 'wbw-search-suggestion__sub';
      var name = venue.venue_name != null ? String(venue.venue_name).trim() : '';
      var cityOnly = wbWizardVenueSearchCityLabel(venue, row.group);
      var locLine = cityOnly || name;
      if (locLine) {
        var venueLine = document.createElement('span');
        venueLine.className = 'wbw-search-suggestion__meta';
        venueLine.textContent = locLine;
        sub.appendChild(venueLine);
      }
      var evMeta = wbWizardVenueEventMeta(venue);
      if (evMeta.date) {
        var dateRow = document.createElement('span');
        dateRow.className = 'wbw-search-suggestion__date-row';
        var dateEl = document.createElement('span');
        dateEl.className = 'wbw-search-suggestion__date';
        dateEl.textContent = evMeta.date;
        dateRow.appendChild(dateEl);
        if (evMeta.more) {
          var moreTag = document.createElement('span');
          moreTag.className = 'wbw-search-suggestion__more';
          moreTag.textContent = 'More';
          dateRow.appendChild(moreTag);
        }
        sub.appendChild(dateRow);
      }
      if (sub.childNodes.length) body.appendChild(sub);
      li.appendChild(thumb);
      li.appendChild(body);
      li.addEventListener('mousedown', function (e) {
        e.preventDefault();
        wbWizardSelectInventoryVenue(row);
      });
      return li;
    }

    function wbWizardPlaceMatchScore(pred, query) {
      var main =
        (pred && pred.structured_formatting && pred.structured_formatting.main_text) ||
        (pred && pred.description) ||
        '';
      return wbWizardMatchScore(main, query);
    }

    function wbWizardRankSuggestions(predictions, venues, query, cities) {
      var q = String(query || '').trim();
      var items = [];
      var kindRank = { city: 0, place: 1, venue: 2 };
      (cities || []).forEach(function (row, index) {
        items.push({
          kind: 'city',
          item: row,
          index: index,
          score: Number(row && row.score) || wbWizardMatchScore(row && row.label, q)
        });
      });
      (venues || []).forEach(function (row, index) {
        items.push({
          kind: 'venue',
          item: row,
          index: index,
          score: Number(row && row.score) || wbWizardMatchScore(row && row.label, q)
        });
      });
      (predictions || []).forEach(function (pred, index) {
        items.push({
          kind: 'place',
          item: pred,
          index: index,
          score: wbWizardPlaceMatchScore(pred, q)
        });
      });
      items.sort(function (a, b) {
        if (a.kind === 'city' && b.kind !== 'city') return -1;
        if (b.kind === 'city' && a.kind !== 'city') return 1;
        if (b.score !== a.score) return b.score - a.score;
        if (a.kind !== b.kind) return (kindRank[a.kind] || 9) - (kindRank[b.kind] || 9);
        return a.index - b.index;
      });
      return items;
    }

    function wbWizardDedupedPredictions(predictions, cities) {
      var names = Object.create(null);
      (cities || []).forEach(function (row) {
        var n = String((row && row.city) || '')
          .trim()
          .toLowerCase();
        if (n) names[n] = true;
      });
      return (predictions || []).filter(function (pred) {
        var main = String(
          (pred && pred.structured_formatting && pred.structured_formatting.main_text) ||
            (pred && pred.description) ||
            ''
        )
          .split(',')[0]
          .trim()
          .toLowerCase();
        return !main || !names[main];
      });
    }

    function wbWizardPaintSearchDropdown() {
      var list = wbWizardEnsureSuggestionList();
      if (!list) return;
      var cities = booking.__wbWizardCitySuggestions || [];
      var predictions = wbWizardDedupedPredictions(booking.__wbWizardPredictions || [], cities);
      var venues = hubCityPickerVisible() ? [] : booking.__wbWizardVenueSuggestions || [];
      list.innerHTML = '';
      if (!predictions.length && !venues.length && !cities.length) {
        list.hidden = true;
        if (locInput) locInput.setAttribute('aria-expanded', 'false');
        return;
      }
      var q = locInput ? String(locInput.value || '').trim() : '';
      var mixed = wbWizardRankSuggestions(predictions, venues, q, cities);
      mixed.forEach(function (entry) {
        var row =
          entry.kind === 'city'
            ? wbWizardBuildCitySuggestion(entry.item, entry.index)
            : entry.kind === 'venue'
              ? wbWizardBuildVenueSuggestion(entry.item, entry.index)
              : wbWizardBuildPlaceSuggestion(entry.item, entry.index);
        if (row) list.appendChild(row);
      });
      list.hidden = false;
      if (locInput) locInput.setAttribute('aria-expanded', 'true');
    }

    function wbWizardSelectInventoryVenue(row) {
      if (!row || !row.venue) return;
      var label = row.label || wbWizardFormatVenueSearchLabel(row.venue, row.group) || '';
      if (locInput) locInput.value = label;
      if (typeof booking.__wbWizardSyncSearchClearBtn === 'function') booking.__wbWizardSyncSearchClearBtn();
      if (typeof booking.__wbWizardSyncSearchReel === 'function') booking.__wbWizardSyncSearchReel();
      wbWizardHideGoogleSuggestions();
      var ref = String(row.refId || row.venue.venue_ref_id || '').trim();
      var card =
        ref && eventsRoot
          ? eventsRoot.querySelector('[data-venue-ref-id="' + (window.CSS && CSS.escape ? CSS.escape(ref) : ref) + '"]')
          : null;
      if (card) {
        card.click();
        try {
          card.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        } catch (_) {}
        return;
      }
      var coords = wbWizardVenueCoords(row.venue);
      if (!coords) return;
      booking.__wbWizardPendingVenueRef = ref;
      if (typeof window !== 'undefined') window.__WB_USER_CHOSEN_LOCATION__ = true;
      fetchEventsByLatLng(booking, coords.lat, coords.lng, 250, {
        source: 'places_autocomplete',
        label: label
      });
    }

    function wbWizardEnsurePlacesSession() {
      var Places = window.google && window.google.maps && window.google.maps.places;
      if (!Places || !Places.AutocompleteSessionToken) return null;
      if (!booking.__wbPlacesSession) {
        booking.__wbPlacesSession = new Places.AutocompleteSessionToken();
      }
      return booking.__wbPlacesSession;
    }

    function wbWizardRenderGoogleSuggestions(predictions) {
      booking.__wbWizardPredictions = predictions || [];
      wbWizardPaintSearchDropdown();
    }

    function wbWizardPredictCacheKey(query) {
      return 'wb_pred:' + String(query || '').trim().toLowerCase();
    }

    function wbWizardReadPredictCache(query) {
      var key = wbWizardPredictCacheKey(query);
      if (booking.__wbPredictMem && booking.__wbPredictMem[key]) return booking.__wbPredictMem[key];
      try {
        var raw = sessionStorage.getItem(key);
        if (!raw) return null;
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length) {
          if (!booking.__wbPredictMem) booking.__wbPredictMem = Object.create(null);
          booking.__wbPredictMem[key] = parsed;
          return parsed;
        }
      } catch (_) {}
      return null;
    }

    function wbWizardWritePredictCache(query, predictions) {
      if (!predictions || !predictions.length) return;
      var key = wbWizardPredictCacheKey(query);
      if (!booking.__wbPredictMem) booking.__wbPredictMem = Object.create(null);
      booking.__wbPredictMem[key] = predictions;
      try {
        sessionStorage.setItem(key, JSON.stringify(predictions));
      } catch (_) {}
    }

    function wbWizardRequestGooglePredictions(query) {
      var q = String(query || '').trim();
      if (q.length < 2 || !googleKey) return;
      var cached = wbWizardReadPredictCache(q);
      if (cached) {
        booking.__wbWizardPredictFor = q;
        wbWizardRenderGoogleSuggestions(cached);
        return;
      }
      if (booking.__wbWizardPredictInflight === q) return;
      booking.__wbWizardPredictInflight = q;
      ensureGooglePlacesLoaded(googleKey)
        .then(function () {
          var Places = window.google && window.google.maps && window.google.maps.places;
          if (!Places || !Places.AutocompleteService) return;
          if (String(locInput.value || '').trim() !== q) return;
          if (!booking.__wbPlacesAutocomplete) {
            booking.__wbPlacesAutocomplete = new Places.AutocompleteService();
          }
          var predictReq = {
            input: q,
            componentRestrictions: { country: 'us' },
            types: ['(cities)'],
            sessionToken: wbWizardEnsurePlacesSession()
          };
          if (google.maps && google.maps.LatLng) {
            predictReq.location = new google.maps.LatLng(WEST_BIAS.lat, WEST_BIAS.lng);
            predictReq.radius = WEST_BIAS.radius;
          }
          booking.__wbPlacesAutocomplete.getPlacePredictions(
            predictReq,
            function (predictions, status) {
              if (booking.__wbWizardPredictInflight === q) booking.__wbWizardPredictInflight = '';
              if (String(locInput.value || '').trim() !== q) return;
              if (status !== Places.PlacesServiceStatus.OK || !predictions) {
                booking.__wbWizardPredictFor = q;
                booking.__wbWizardPredictions = [];
                wbWizardPaintSearchDropdown();
                return;
              }
              var sliced = predictions.slice(0, 5);
              booking.__wbWizardPredictFor = q;
              wbWizardWritePredictCache(q, sliced);
              wbWizardRenderGoogleSuggestions(sliced);
            }
          );
        })
        .catch(function (err) {
          if (booking.__wbWizardPredictInflight === q) booking.__wbWizardPredictInflight = '';
          if (window.__WB_DIAG__) console.warn('[WB] autocomplete skipped', err);
        });
    }

    function wbWizardSelectGooglePrediction(pred) {
      if (!pred || !pred.place_id) return;
      var label = pred.description || '';
      if (locInput) locInput.value = label;
      if (typeof booking.__wbWizardSyncSearchClearBtn === 'function') booking.__wbWizardSyncSearchClearBtn();
      if (typeof booking.__wbWizardSyncSearchReel === 'function') booking.__wbWizardSyncSearchReel();
      wbWizardHideGoogleSuggestions();
      ensureGooglePlacesLoaded(googleKey)
        .then(function () {
          var Places = window.google && window.google.maps && window.google.maps.places;
          if (!Places || !Places.PlacesService) {
            wbWizardGeocodeAndRecenter(label);
            return;
          }
          if (!booking.__wbPlacesDetailsHost) {
            booking.__wbPlacesDetailsHost = document.createElement('div');
          }
          if (!booking.__wbPlacesDetails) {
            booking.__wbPlacesDetails = new Places.PlacesService(booking.__wbPlacesDetailsHost);
          }
          booking.__wbPlacesDetails.getDetails(
            {
              placeId: pred.place_id,
              fields: ['geometry', 'name', 'formatted_address'],
              sessionToken: booking.__wbPlacesSession || undefined
            },
            function (place, status) {
              booking.__wbPlacesSession = null;
              if (status !== Places.PlacesServiceStatus.OK || !place || !place.geometry || !place.geometry.location) {
                wbWizardGeocodeAndRecenter(label);
                return;
              }
              var loc = place.geometry.location;
              var lat = typeof loc.lat === 'function' ? loc.lat() : loc.lat;
              var lng = typeof loc.lng === 'function' ? loc.lng() : loc.lng;
              if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
                wbWizardGeocodeAndRecenter(label);
                return;
              }
              booking.__wbWizardLastGeocodeQ = label;
              if (typeof window !== 'undefined') window.__WB_USER_CHOSEN_LOCATION__ = true;
              if (hubApplyOrigin(lat, lng, label, 'places_autocomplete')) return;
              fetchEventsByLatLng(booking, lat, lng, 250, {
                source: 'places_autocomplete',
                label: label
              });
            }
          );
        })
        .catch(function () {
          wbWizardGeocodeAndRecenter(label);
        });
    }

    function setupWizardVenueTitleScroll() {
      var scroller = booking.querySelector('[data-events-panel="1"]');
      var header = booking.querySelector('[data-available-events-header]');
      if (!scroller || !header || scroller.getAttribute('data-wbw-title-scroll') === '1') return;
      scroller.setAttribute('data-wbw-title-scroll', '1');
      var idleTimer = 0;
      function onVenueListScroll() {
        var y = scroller.scrollTop || 0;
        if (y > 10) header.classList.add('wbw-venue-title-away');
        else header.classList.remove('wbw-venue-title-away');
        clearTimeout(idleTimer);
        idleTimer = setTimeout(function () {
          header.classList.remove('wbw-venue-title-away');
        }, 220);
      }
      scroller.addEventListener('scroll', onVenueListScroll, { passive: true });
    }

    function setupWizardVenueInventorySearch() {
      if (!wbWizardInventorySearchActive() || !locInput) return;
      if (locInput.getAttribute('data-wbw-inventory-search') === '1') return;
      locInput.setAttribute('data-wbw-inventory-search', '1');
      locInput.setAttribute('autocomplete', 'off');
      locInput.setAttribute('autocorrect', 'off');
      locInput.setAttribute('autocapitalize', 'none');
      locInput.setAttribute('spellcheck', 'false');
      locInput.setAttribute('role', 'combobox');
      locInput.setAttribute('aria-autocomplete', 'list');
      locInput.setAttribute('aria-expanded', 'false');
      locInput.setAttribute('aria-controls', 'wbw-search-suggestions');
      locInput.removeAttribute('aria-activedescendant');
      locInput.removeAttribute('style');
      locInput.classList.remove('wbw-search-native-hidden');
      locInput.style.display = '';
      var wrap = locInput.closest('.wb-search-input-wrap');
      if (wrap) wrap.classList.remove('wbw-search-has-place');
      wbWizardEnsureSuggestionList();

      var clearBtn =
        (wrap && wrap.querySelector('[data-workshop-search-clear]')) ||
        booking.querySelector('[data-workshop-search-clear]');

      function wbWizardSyncSearchClearBtn() {
        if (!clearBtn || !locInput) return;
        var hasValue = String(locInput.value || '').trim().length > 0;
        if (hasValue) {
          clearBtn.removeAttribute('hidden');
          clearBtn.setAttribute('aria-hidden', 'false');
        } else {
          clearBtn.setAttribute('hidden', '');
          clearBtn.setAttribute('aria-hidden', 'true');
        }
      }
      booking.__wbWizardSyncSearchClearBtn = wbWizardSyncSearchClearBtn;

      function wbWizardSyncSearchReel() {
        if (!wrap || !locInput) return;
        var busy =
          document.activeElement === locInput || String(locInput.value || '').trim().length > 0;
        wrap.classList.toggle('wbw-search-is-active', busy);
      }
      booking.__wbWizardSyncSearchReel = wbWizardSyncSearchReel;
      wbWizardSyncSearchReel();

      function wbWizardClearSearchInput() {
        if (!locInput) return;
        locInput.value = '';
        wbSetLocationUi({ clear: true });
        wbWizardHideGoogleSuggestions();
        if (hubCityPickerVisible()) {
          var Hub = hubApi();
          if (Hub && typeof Hub.clearSearchOrigin === 'function') Hub.clearSearchOrigin(booking);
        } else {
          wbWizardApplyInventoryFilter('');
        }
        wbWizardSyncSearchClearBtn();
        wbWizardSyncSearchReel();
        try {
          locInput.focus();
        } catch (_) {}
      }

      wbWizardSyncSearchClearBtn();
      wbWizardSyncSearchReel();

      if (clearBtn && clearBtn.getAttribute('data-wbw-clear-bound') !== '1') {
        clearBtn.setAttribute('data-wbw-clear-bound', '1');
        clearBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          wbWizardClearSearchInput();
        });
      }

      locInput.addEventListener('input', function () {
        wbWizardSyncSearchClearBtn();
        wbWizardSyncSearchReel();
        wbWizardLiveFilterFromInput();
      });

      locInput.addEventListener('focus', function () {
        wbWizardSyncSearchReel();
        if (googleKey) ensureGooglePlacesLoaded(googleKey).catch(function () {});
      });

      locInput.addEventListener('blur', function () {
        wbWizardSyncSearchReel();
      });

      locInput.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          wbWizardInventorySearchSubmit();
        } else if (e.key === 'Escape') {
          wbWizardHideGoogleSuggestions();
        }
      });

      document.addEventListener('click', function (e) {
        if (!wrap || wrap.contains(e.target)) return;
        wbWizardHideGoogleSuggestions();
      });

      booking.__wbTriggerDefaultPrefetch = function () {
        wbWizardInventorySearchSubmit();
      };

      document.addEventListener('wbw:venue-list-rendered', function () {
        var pendingRef = String(booking.__wbWizardPendingVenueRef || '').trim();
        if (pendingRef && eventsRoot) {
          booking.__wbWizardPendingVenueRef = '';
          var pendingCard = eventsRoot.querySelector(
            '[data-venue-ref-id="' + (window.CSS && CSS.escape ? CSS.escape(pendingRef) : pendingRef) + '"]'
          );
          if (pendingCard) pendingCard.click();
        }
        if (booking.__wbWizardInventoryFilterActive) return;
        if (!wbWizardHasRenderableVenueList(booking.__wbWizardInitialVenueList)) {
          if (wbWizardHasRenderableVenueList(window.__WORKSHOP_VENUE_LIST__)) {
            wbWizardStoreInitialVenueList(window.__WORKSHOP_VENUE_LIST__);
          }
        }
      });
    }


      S.ensureGoogleMapsCoreLoaded = ensureGoogleMapsCoreLoaded;
      S.wbWizardReadGeocodeCache = wbWizardReadGeocodeCache;
      S.wbWizardWriteGeocodeCache = wbWizardWriteGeocodeCache;
      S.wbWizardGeocodeAndRecenter = wbWizardGeocodeAndRecenter;
      S.wbWizardEnsureSuggestionList = wbWizardEnsureSuggestionList;
      S.wbWizardHideGoogleSuggestions = wbWizardHideGoogleSuggestions;
      S.wbWizardBuildPlaceSuggestion = wbWizardBuildPlaceSuggestion;
      S.wbWizardBuildVenueSuggestion = wbWizardBuildVenueSuggestion;
      S.wbWizardPlaceMatchScore = wbWizardPlaceMatchScore;
      S.wbWizardRankSuggestions = wbWizardRankSuggestions;
      S.wbWizardPaintSearchDropdown = wbWizardPaintSearchDropdown;
      S.wbWizardSelectHubCity = wbWizardSelectHubCity;
      S.wbWizardSelectInventoryVenue = wbWizardSelectInventoryVenue;
      S.wbWizardEnsurePlacesSession = wbWizardEnsurePlacesSession;
      S.wbWizardRenderGoogleSuggestions = wbWizardRenderGoogleSuggestions;
      S.wbWizardPredictCacheKey = wbWizardPredictCacheKey;
      S.wbWizardReadPredictCache = wbWizardReadPredictCache;
      S.wbWizardWritePredictCache = wbWizardWritePredictCache;
      S.wbWizardRequestGooglePredictions = wbWizardRequestGooglePredictions;
      S.wbWizardSelectGooglePrediction = wbWizardSelectGooglePrediction;
      S.setupWizardVenueTitleScroll = setupWizardVenueTitleScroll;
      S.setupWizardVenueInventorySearch = setupWizardVenueInventorySearch;
    }
  };
})(typeof window !== "undefined" ? window : this);
